import styled from 'styled-components';

export const Container = styled.div`
  padding: 2.38rem;

  > a:first-child {
    background: none;
    display: flex;
    align-items: center;
    color: #323232;
    text-align: center;
    margin-bottom: 1rem;
    font-family: 'RedhatDisplay-Bold';
    font-size: 1.1em;
    width: fit-content;
    transition: opacity 0.3s;
    opacity: 0.8;

    svg {
      margin-right: 0.4rem;
    }

    &:hover {
      opacity: 1;

      > svg {
        opacity: 1;
      }
    }
  }

  @media (max-width: 48rem) {
    padding: 1rem;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e2e2;

  h1 {
    font-family: 'RedHatDisplay-ExtraBold';
    color: #1e88e5;
    font-size: 1.8rem;
    line-height: 2.2rem;
  }

  @media (max-width: 48rem) {
    h1 {
      font-size: 1.3rem;
      line-height: 1.7rem;
    }
  }
`;

export const MainCard = styled.div`
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 1rem;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  @media (max-width: 48rem) {
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 0.75rem;
  }
`;

export const MainCardContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.5rem;
  align-items: flex-start;

  @media (max-width: 48rem) {
    flex-direction: column;
    gap: 0.75rem;
    align-items: stretch;
  }
`;

export const TrophyImageWrapper = styled.div`
  flex: 0 0 16.25rem;
  width: 16.25rem;
  height: 16.25rem;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: visible;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: relative;
    z-index: 2;
  }

  svg {
    z-index: 1;
  }

  @media (max-width: 48rem) {
    flex: unset;
    align-self: center;
    width: 6rem;
    height: 6rem;
  }
`;

export const TournamentInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const TournamentTitle = styled.h2`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.6rem;
  color: #323232;
  margin: 0;

  @media (max-width: 48rem) {
    font-size: 1.2rem;
    text-align: center;
  }
`;

export const TournamentMeta = styled.p`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.9rem;
  color: #6b7280;
  margin: 0;

  strong {
    font-family: 'RedHatDisplay-Bold';
    color: #323232;
  }

  @media (max-width: 48rem) {
    font-size: 0.8rem;
    text-align: center;
  }
`;

export const ModalitiesLabel = styled.p`
  font-family: 'RedHatDisplay-Medium';
  font-size: 0.9rem;
  color: #323232;
  margin: 0;
`;

export const ModalitiesRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 48rem) {
    gap: 0.6rem;
  }
`;

export const ModalityCard = styled.div<{ $active?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  border: 2px solid #ff9800;
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  background: #fff;
  min-width: 11.25rem;

  @media (max-width: 48rem) {
    min-width: unset;
    width: 100%;
    padding: 0.6rem 0.75rem;
    gap: 0.6rem;
  }
`;

export const ModalityImage = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  object-fit: contain;

  @media (max-width: 48rem) {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

export const ModalityInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const ModalityName = styled.span`
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.95rem;
  color: #323232;
`;

export const ModalityMeta = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.78rem;
  color: #6b7280;
`;

export const CategoryBadgeRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.35rem;
`;

export const CategoryBadge = styled.span`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: #dbeafe;
  color: #1e88e1;
  border-radius: 4px;
  padding: 0.2rem 0.5rem;
  font-size: 0.72rem;
  font-family: 'RedHatDisplay-Medium';
`;

export const ActionButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;

  .secondary-button {
    height: 2.8rem;
    font-size: 0.9rem;
    padding: 0 1.2rem;
    border-radius: 0.55rem;
    border: 1.5px solid #323232;
    color: #323232;
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  .secondary-button {
    &:hover {
      color: #4caf50;
      border: 1px solid #4caf50;
      svg {
        transition: transform 0.3s;
        stroke: #4caf50;
      }
    }
  }

  @media (max-width: 48rem) {
    flex-direction: column;
    gap: 0.6rem;

    .secondary-button {
      width: 100%;
      justify-content: center;
      height: 3rem;
      font-size: 0.95rem;
    }
  }
`;

export const ScheduleSection = styled.div`
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 1rem;
  padding: 1.5rem 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  @media (max-width: 48rem) {
    padding: 1rem;
    border-radius: 0.75rem;
  }
`;

export const ScheduleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;

  h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.4rem;
    color: #323232;
  }

  @media (max-width: 48rem) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 1rem;

    h2 {
      font-size: 1.2rem;
    }
  }
`;

export const ScheduleHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  .secondary-button {
    height: 2.8rem;
    font-size: 0.9rem;
    padding: 0 1.2rem;
    border-radius: 0.55rem;
    border: 1.5px solid #1e88e5;
    color: #1e88e5;
    display: flex;
    align-items: center;
    gap: 0.4rem;

    &:hover {
      color: #4caf50;
      border: 1px solid #4caf50;
      svg {
        transition: transform 0.3s;
        stroke: #4caf50;
      }
    }
  }

  .primary-button {
    height: 2.8rem;
    font-size: 0.9rem;
    padding: 0 1.2rem;
    border-radius: 0.55rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    box-shadow: 0px 3px 8px rgba(255, 152, 0, 0.3);
  }

  @media (max-width: 48rem) {
    width: 100%;
    flex-direction: column;
    gap: 0.6rem;

    .secondary-button,
    .primary-button {
      width: 100%;
      justify-content: center;
      height: 3rem;
      font-size: 0.95rem;
    }
  }
`;

export const ScrollHint = styled.p`
  display: none;

  @media (max-width: 48rem) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.75rem;
    color: #9ca3af;
    margin: 0.25rem 0 0.5rem;
  }
`;

export const ScheduleTableWrapper = styled.div`
  border: 1px solid #e2e2e2;
  border-radius: 0.75rem;
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 0.5rem;
  -webkit-overflow-scrolling: touch;
`;

export const ScheduleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 43.75rem;

  @media (max-width: 48rem) {
    thead th:first-child {
      position: sticky;
      left: 0;
      z-index: 3;
      background: #fafafa;
      box-shadow: 2px 0 6px rgba(0, 0, 0, 0.08);
    }

    tbody td:first-child {
      position: sticky;
      left: 0;
      z-index: 2;
      background: #fff;
      box-shadow: 2px 0 6px rgba(0, 0, 0, 0.08);
    }
  }
`;

export const ScheduleTableHead = styled.thead`
  background: #fafafa;
  border-bottom: 1px solid #ebebeb;
`;

export const ScheduleTh = styled.th`
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.85rem;
  color: #555;
  padding: 0.9rem 1rem;
  text-align: center;
  white-space: nowrap;
  font-weight: normal;
`;

interface IScheduleTableRowProps {
  $status?: string;
}

export const ScheduleTableRow = styled.tr<IScheduleTableRowProps>`
  border-bottom: 1px solid #f5f5f5;
  transition: background 0.15s;
  background: ${({ $status }) =>
    $status === 'completed' ? 'rgba(212, 237, 218, 0.25)' : 'transparent'};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ $status }) =>
      $status === 'completed'
        ? 'rgba(212, 237, 218, 0.45)'
        : 'rgba(255, 152, 0, 0.03)'};
  }
`;

export const ScheduleTd = styled.td`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.9rem;
  color: #323232;
  padding: 0.75rem 1rem;
  text-align: center;
  white-space: nowrap;
`;

export const ViewRoundButton = styled.button`
  background: none;
  border: 1.5px solid #1e88e5;
  border-radius: 20px;
  color: #1e88e5;
  font-size: 0.75rem;
  font-family: 'RedHatDisplay-Medium';
  padding: 0.25rem 0.75rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;

  &:hover {
    background: #dbeafe;
  }
`;

export const ViewResultButton = styled.button`
  background: none;
  border: 1.5px solid #16a34a;
  border-radius: 20px;
  color: #16a34a;
  font-size: 0.75rem;
  font-family: 'RedHatDisplay-Medium';
  padding: 0.25rem 0.75rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;

  &:hover {
    background: #dcfce7;
  }
`;

export const DisqualifyButton = styled.button`
  background: none;
  border: 1.5px solid #ef4444;
  border-radius: 20px;
  color: #ef4444;
  font-size: 0.75rem;
  font-family: 'RedHatDisplay-Medium';
  padding: 0.25rem 0.75rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;

  &:hover {
    background: #dcfce7;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem;
`;

export const Spinner = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border: 3px solid #e0e0e0;
  border-top-color: #ff9800;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

// ── Próxima Rodada ──────────────────────────────────────────────────────────

export const NextSlotCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  background: #fff8ef;
  border: 1.5px solid #ff9800;
  border-radius: 0.75rem;
  padding: 1rem 1.5rem;
  margin-bottom: 1.25rem;

  @media (max-width: 48rem) {
    padding: 0.75rem 1rem;
  }
`;

export const NextSlotLabel = styled.span`
  font-family: 'RedHatDisplay-Medium';
  font-size: 0.72rem;
  color: #ff9800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const NextSlotTeam = styled.p`
  font-family: 'RedHatDisplay-ExtraBold';
  font-size: 1.25rem;
  color: #323232;
  margin: 0;

  @media (max-width: 48rem) {
    font-size: 1.05rem;
  }
`;

export const NextSlotMeta = styled.p`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.85rem;
  color: #6b7280;
  margin: 0;
`;

// ── Tabs ─────────────────────────────────────────────────────────────────────

export const TabBar = styled.div`
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e2e2e2;
  margin-bottom: 1.25rem;
`;

interface ITabProps {
  $active: boolean;
}

export const Tab = styled.button<ITabProps>`
  background: none;
  border: none;
  border-bottom: 2.5px solid
    ${({ $active }) => ($active ? '#FF9800' : 'transparent')};
  margin-bottom: -2px;
  padding: 0.65rem 1.25rem;
  font-family: ${({ $active }) =>
    $active ? "'RedHatDisplay-Bold'" : "'RedHatDisplay-Regular'"};
  font-size: 0.95rem;
  color: ${({ $active }) => ($active ? '#FF9800' : '#6b7280')};
  cursor: pointer;
  transition:
    color 0.2s,
    border-color 0.2s;

  &:hover {
    color: #ff9800;
  }

  @media (max-width: 48rem) {
    flex: 1;
    text-align: center;
    font-size: 0.88rem;
    padding: 0.65rem 0.5rem;
  }
`;

// ── Status badge na tabela ────────────────────────────────────────────────────

interface ISlotStatusProps {
  $status: string;
}

export const SlotStatusPill = styled.span<ISlotStatusProps>`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.6rem;
  border-radius: 20px;
  font-size: 0.72rem;
  font-family: 'RedHatDisplay-Medium';
  white-space: nowrap;

  ${({ $status }) =>
    $status === 'completed'
      ? 'background: #d4edda; color: #155724;'
      : $status === 'ongoing'
        ? 'background: #fff3cd; color: #856404;'
        : 'background: #dbeafe; color: #1e88e1;'}
`;

// ── Ranking ───────────────────────────────────────────────────────────────────

export const RankingSection = styled.div`
  margin-bottom: 2rem;
`;

export const RankingTitle = styled.h3`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.1rem;
  color: #323232;
  margin: 0 0 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const RankingTableWrapper = styled.div`
  border: 1px solid #e2e2e2;
  border-radius: 0.75rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const RankingTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 25rem;

  thead {
    background: #fafafa;
    border-bottom: 1px solid #ebebeb;
  }

  th {
    font-family: 'RedHatDisplay-Bold';
    font-size: 0.85rem;
    color: #555;
    padding: 0.75rem 1rem;
    text-align: center;
    font-weight: normal;
    white-space: nowrap;
  }

  td {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.9rem;
    color: #323232;
    padding: 0.7rem 1rem;
    text-align: center;
    border-bottom: 1px solid #f5f5f5;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background: rgba(255, 152, 0, 0.03);
  }
`;

export const MedalCell = styled.td<{ $position: number }>`
  font-size: ${({ $position }) => ($position <= 3 ? '1.25rem' : '0.9rem')};
  font-family: 'RedHatDisplay-Bold' !important;
  color: ${({ $position }) =>
    $position === 1
      ? '#b8860b'
      : $position === 2
        ? '#757575'
        : $position === 3
          ? '#8b4513'
          : '#323232'} !important;
  width: 3rem;
`;

// ── Agrupamento por rodada ───────────────────────────────────────────────────

export const RoundHeaderRow = styled.tr`
  background: #eef4fb;
  border-top: 1.5px solid #c5d9f5;
  border-bottom: 1px solid #dde8f7;
`;

export const RoundHeaderCell = styled.td`
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.78rem;
  color: #1e88e5;
  padding: 0.45rem 1rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.65rem;
  flex-wrap: wrap;
  background: #f9fafb;
  border: 1px solid #ebebeb;
  border-radius: 0.75rem;
  padding: 0.85rem 1rem;
  margin-bottom: 1.25rem;
`;

export const FilterRowTitle = styled.span`
  flex-basis: 100%;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.78rem;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 0.1rem;
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

export const FilterFieldLabel = styled.span`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.8rem;
  color: #6b7280;
  padding-left: 0.1rem;
`;

interface IFilterInputProps {
  $isFocused: boolean;
}

export const FilterInput = styled.div<IFilterInputProps>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: 1.5px solid
    ${({ $isFocused }) => ($isFocused ? '#1e88e5' : '#d1d5db')};
  border-radius: 0.55rem;
  padding: 0 0.85rem;
  height: 2.75rem;
  background: #fff;
  width: 200px;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  box-shadow: ${({ $isFocused }) =>
    $isFocused ? '0 0 0 3px rgba(30, 136, 229, 0.1)' : 'none'};

  svg {
    flex-shrink: 0;
  }

  input {
    border: none;
    background: transparent;
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.88rem;
    color: #323232;
    width: 100%;

    &::placeholder {
      color: #9ca3af;
    }

    &:focus {
      outline: none;
    }
  }
`;

export const ClearFiltersLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 20px;
  cursor: pointer;
  color: #dc2626;
  font-family: 'RedHatDisplay-Medium';
  font-size: 0.78rem;
  padding: 0.3rem 0.75rem;
  margin-left: auto;
  white-space: nowrap;
  transition: background 0.2s;

  &:hover {
    background: #fecaca;
  }
`;

export const FilterResultCount = styled.span`
  font-family: 'RedHatDisplay-Medium';
  font-size: 0.78rem;
  color: #6b7280;
  white-space: nowrap;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  padding: 0.25rem 0.65rem;
`;

// ── Status + dicas de pré-requisitos ────────────────────────────────────────

export const StatusAndHintsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
`;

export const PrerequisitePill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.18rem 0.65rem;
  border-radius: 20px;
  font-size: 0.7rem;
  font-family: 'RedHatDisplay-Medium';
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #fbbf24;
  background: #fffbeb;
  color: #92400e;
  transition:
    background 0.15s,
    border-color 0.15s;

  &:hover {
    background: #fef3c7;
    border-color: #f59e0b;
  }
`;

// ── Empty state do cronograma ────────────────────────────────────────────────

export const ScheduleEmptyCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  padding: 3rem 2rem;

  .primary-button {
    height: 2.8rem;
    font-size: 0.9rem;
    padding: 0 1.2rem;
    border-radius: 0.55rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    box-shadow: 0px 3px 8px rgba(255, 152, 0, 0.3);
  }
`;

export const ScheduleEmptyTitle = styled.p`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.05rem;
  color: #323232;
  margin: 0;
`;

export const ScheduleEmptyDesc = styled.p`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.88rem;
  color: #6b7280;
  margin: 0;
  max-width: 440px;
`;

export const PrerequisiteChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
`;

export const PrerequisiteChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 1rem;
  border-radius: 0.55rem;
  font-size: 0.85rem;
  font-family: 'RedHatDisplay-Medium';
  white-space: nowrap;
  cursor: pointer;
  border: 1.5px solid #f59e0b;
  background: #fffbeb;
  color: #92400e;
  transition: background 0.15s;

  &:hover {
    background: #fef3c7;
  }
`;

// ── Status badges do torneio ─────────────────────────────────────────────────

interface IStatusBadgeProps {
  $status: string;
}

export const TournamentStatusBadge = styled.span<IStatusBadgeProps>`
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.6rem;
  border-radius: 20px;
  font-size: 0.72rem;
  font-family: 'RedHatDisplay-Medium';
  width: fit-content;

  @media (max-width: 48rem) {
    align-self: center;
  }

  ${({ $status }) =>
    $status === 'planning' || $status === 'planned'
      ? `background: #fff3cd; color: #856404;`
      : $status === 'open'
        ? `background: #dbeafe; color: #1e88e1;`
        : $status === 'completed'
          ? `background: #d4edda; color: #155724;`
          : `background: #f3f4f6; color: #6b7280;`}
`;
